import WithRender from "../../templates/layouts/layoutUpload.html";

export default WithRender({});
